import { createIcon } from '../shared'

const RepostIcon = createIcon(
  ({ color }) => (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.7256 10.1062L7.33168 11.7784L11.1064 11.6989C11.4912 11.6905 11.7984 11.376 11.7986 10.9911V6.10502H13.9228V10.9911C13.9226 12.5313 12.6913 13.7893 11.1514 13.8221L7.25131 13.9042L8.7256 15.675H5.96203L3.64335 12.8906L5.96203 10.1062H8.7256Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.2714 5.89373L8.66532 4.22154L4.89058 4.30104C4.50579 4.30937 4.19855 4.62394 4.19837 5.00881V9.89488H2.07422V5.00881C2.0744 3.46858 3.30573 2.21062 4.84564 2.17775L8.74569 2.09566L7.2714 0.324951H10.035L12.3536 3.10934L10.035 5.89373H7.2714Z"
        fill={color}
      />
    </>
  ),
  '0 0 16 16',
  'RepostIcon',
)

export { RepostIcon }
